import { Injectable } from '@angular/core';
import { BaseHttpService } from './base-http.service';
import { PersonalParamsScope } from '@shared/types/personal-params';
import { DashboardTypes } from '@shared/models/api-request/me.models';
import { PersonalParamDto } from '@shared/interfaces/dtos/params';
import { Observable } from 'rxjs';
import { CreatePersonalParams, UpdatePersonalParams } from '@shared/interfaces/params';

@Injectable({
  providedIn: 'root',
})
export class PersonalParamsService extends BaseHttpService {
  protected endPoint: string = 'Me/Configurations/PersonalParams';

  private scopeMap = new Map<PersonalParamsScope, DashboardTypes>([
    ['favorites', DashboardTypes.IDelibeBackofficeFavoris],
    ['savedSearches', DashboardTypes.IDelibeBackofficeRechercheSauvegardee],
    ['customViews', DashboardTypes.IDelibeBackofficeCustomViews],
  ]);

  public insertNewPersonalParam(config: {
    body: CreatePersonalParams;
    scope: PersonalParamsScope;
  }): Observable<unknown> {
    const { body, scope } = config;
    return this.http.post<unknown>(this.buildURL(), body, {
      params: {
        type: this.scopeMap.get(scope),
      },
    });
  }

  public fetchPersonalParams(scope: PersonalParamsScope): Observable<PersonalParamDto[]> {
    return this.http.get<PersonalParamDto[]>(this.buildURL(), { params: { type: this.scopeMap.get(scope) } });
  }

  public updatePersonalParam(config: {
    paramId: number;
    body: UpdatePersonalParams;
    scope: PersonalParamsScope;
  }): Observable<void> {
    const { paramId, body, scope } = config;
    return this.http.put<void>(this.buildURL({ idOrSubEndpoint: paramId }), body, {
      params: { type: this.scopeMap.get(scope) },
    });
  }

  public deletePersonalParam(config: { paramId: number; scope: PersonalParamsScope }): Observable<void> {
    const { paramId, scope } = config;
    return this.http.delete<void>(this.buildURL({ idOrSubEndpoint: paramId }), {
      params: { type: this.scopeMap.get(scope) },
    });
  }
}
